<template>
<div class="concierce_voucher-slide">
    <div class="inner">
        <span class="ico_voucher">
            <img src="../images/concierce_voucher_label.png" alt="VOUCHER">
        </span>

        <h2 class="title">
            다이아몬드 컨시어지<br>파이토 카페 음료 바우처
        </h2>

        <div class="use_limit">
            <span>이용기한</span>
            <p>{{EndDate}}</p>
        </div>

        <div class="voucher_slide">
            <carousel v-if="coupons.length > 1" :autoplay="false" :loop="false" :autoHeight="true" :items="1" 
                :responsive="{768:{nav:false}}" @changed.owl.carousel="changedOwlCarousel" >
                <div v-for="coupon in coupons">
                    <div class="item">
                        <div class="voucher_post">
                            <div class="voucher_expiration" v-if="coupon && coupon.isexpired">
                                <span>이용기한 만료</span>
                            </div>

                            <div class="voucher_post-img">
                                <img src="../images/concierce_voucher1.png" alt="">
                            </div>

                            <div class="voucher_post-info">
                                <div class="voucher_post-text"> 
                                    <div class="voucher_post-amount">
                                        <span>{{coupon.total_coupon_sum}}</span> 매
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="voucher_btn_box" v-if="coupon && !coupon.isexpired">
                            <button type="button" class="voucher_btn use" @click="useCoupon(coupon.total_coupon_sum)" >사용하기</button>
                            <button type="button" class="voucher_btn gift" @click="sendGift" >선물하기</button>
                        </div>
                    </div>
                </div>
            </carousel>
            <template v-else-if="coupons.length > 0">
                <div class="item">
                    <div class="voucher_post">
                        <div class="voucher_expiration" v-if="coupons[0].isexpired">
                            <span>이용기한 만료</span>
                        </div>

                        <div class="voucher_post-img">
                            <img src="../images/concierce_voucher1.png" alt="">
                        </div>

                        <div class="voucher_post-info">
                            <div class="voucher_post-text"> 
                                <div class="voucher_post-amount">
                                    <span>{{coupons[0].total_coupon_sum}}</span> 매
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="voucher_btn_box" v-if="!coupons[0].isexpired">
                        <button type="button" class="voucher_btn use" @click="useCoupon(coupons[0].total_coupon_sum)" >사용하기</button>
                        <button type="button" class="voucher_btn gift" @click="sendGift" >선물하기</button>
                    </div>
                </div>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import carousel from 'vue-owl-carousel'
import axios from 'axios'

export default {
    name: 'voucher',
    components: {
        carousel
    },
    props:{
        coupons: Array,
        aboInfo: {}
    },
    data () {
        return {
            idx: Number,
        }
    },
    methods: {
        changedOwlCarousel: function(e){
            this.idx=e.item.index;
            console.log('idx : ' + this.idx);
            this.$emit('couponIdx', this.coupons[this.idx]); 
        },
        sendGift: function(){
            if(this.coupons[this.idx].total_coupon_sum <= 0){
                alert('발송할 바우처가 없습니다.')
            }else{
                this.$router.push({name: '/concierge/conciergeSendGift', params: { 
                userId: this.coupons[this.idx].id,
                aboInfo: this.aboInfo
                }})
            }
        },
        async useCoupon () {
            await axios.post(process.env.AWS_GATEWAY_URL_V2 + '/event-admin/concierge-login-info',{
                abo_no : this.aboInfo.aboNo
            }).then(response => {
                let coupon_info = JSON.parse(response.data.results) // 쿠폰 리스트
                let coupon_sum = coupon_info[this.idx].total_coupon_sum // [Index] 쿠폰 보유수량 구하기
                // 보유수량 렌더링
                this.coupons.total_coupon_sum = coupon_sum
                this.useCouponValidCheck(coupon_sum)
            })
        },
        useCouponValidCheck (coupon_sum) {
            console.log("Voucher - useCouponYn : " , coupon_sum)
            if (coupon_sum <= 0){
                alert('사용할 바우처가 없습니다.')
                this.coupons[this.idx].total_coupon_sum = coupon_sum
                console.log(this.coupons[this.idx].total_coupon_sum)
            }else {
                this.$router.push({name: '/concierge/myCouponDTL', params: { 
                    targetUserId: this.coupons[this.idx].id,
                    aboNm: this.aboInfo.aboName,
                    endDate: this.coupons[this.idx].end_date,
                    total_coupon_sum: coupon_sum
                }})
            }
        },
        makeDateFormat:function(tDate){
            if(tDate){
                const dt = new Date(tDate);
                return dt.getFullYear()+"년 "+(dt.getMonth()+1)+"월 "+dt.getDate()+"일 까지";
            }
        }, 
    },
    computed: {
        EndDate: function(){
            if(this.coupons.length > 0 && this.coupons[this.idx] !== undefined)
                return this.makeDateFormat(this.coupons[this.idx].end_date);
            else
                return " ";
        }
    },
    mounted() {
        this.idx=0;
    },
}
</script>



// WEBPACK FOOTER //
// src/views/concierge/component/voucher.vue